import React from 'react'
import { graphql } from 'gatsby'
import { GatsbyImage } from "gatsby-plugin-image";

import Animation from '../components/Animation'
import AnimationTeaser from '../components/AnimationTeaser'
import Badge from '../components/Badge'
import Button from '../components/Button'
import Container from '../components/Container'
import Grid from '../components/Grid'
import GridCell from '../components/GridCell'
import Headline from '../components/Headline'
import News from '../components/News'
import Paragraph from '../components/Paragraph'
import Section from '../components/Section'
import TextLink from '../components/TextLink'

import Page from '../partials/Page'

import teaserData from '../assets/animations/home/data.json'
import lightningTeaserData from '../assets/animations/lightning/data.json'

const IndexPage = ({
  data: {
    markdownRemark: { frontmatter },
    screenshot
  },
  location
}) => (
  <Page
    title={frontmatter.title}
    description={frontmatter.description}
    location={location}
  >
    <Section theme="home" size="teaser" noPadding>
      <Container>
        <AnimationTeaser animation={<Animation animationData={teaserData} />}>
          <Grid>
            <GridCell m={6}>
              <Headline heroThin classNames={['u-space-xl']}>
                <strong>Lightning Labs</strong>
                <br />
                building faster, cheaper, global
                <br />
                <strong>layer-two bitcoin</strong>
              </Headline>
              <Paragraph classNames={['u-space-s']}>
                <Button href="/products">See our products</Button>
              </Paragraph>
              <Paragraph>
                <Button href="/join-us" ghost invert>
                  Join us
                </Button>
              </Paragraph>
            </GridCell>
          </Grid>
        </AnimationTeaser>
      </Container>
    </Section>
    {frontmatter.news && frontmatter.news.title && (
      <Section size="s" theme="alternative">
        <Container>
          <News>
            <Badge>News</Badge>
            <TextLink inherit href={frontmatter.news.url}>
              {frontmatter.news.title}
            </TextLink>
          </News>
        </Container>
      </Section>
    )}
    <Section size="l" theme="dark" noPadding>
      <Container>
        <AnimationTeaser
          animation={<Animation animationData={lightningTeaserData} />}
        >
          <Grid>
            <GridCell m={6}>
              <Headline heroThin classNames={['u-space-l']}>
                Who are we?
              </Headline>
              <Paragraph invert>
                At Lightning Labs, we develop software that powers the Lightning
                Network. Our open source, secure, and scalable Lightning systems
                enable users to send and receive money more efficiently than
                ever before. We also offer a series of verifiable, non-custodial
                Lightning-based financial services. We bridge the world of open
                source software and the next-generation of bitcoin financial
                software.
              </Paragraph>
            </GridCell>
          </Grid>
        </AnimationTeaser>
      </Container>
    </Section>
    <Section size="l">
      <Container>
        <Grid>
          <GridCell m={6}>
            <GatsbyImage
              image={screenshot.childImageSharp.gatsbyImageData}
              alt="Lightning terminal screenshot"
              className="u-drop-shadow"
            />
          </GridCell>
          <GridCell m={6}>
            <Headline large classNames={['u-space-l']}>
              <strong>Lightning Terminal</strong>
            </Headline>
            <Headline heroSub classNames={['u-space-l']} tag="h2">
              Simple Lightning node management
            </Headline>
            <Paragraph classNames={['u-space-l']}>
              Terminal provides a simple web UI for node operators to improve
              the quality and liquidity of their node. It makes running a
              Lightning node simpler, easier, and more accessible, lowering the
              barrier to instant, high volume, low fee bitcoin transactions for
              all.
            </Paragraph>
            <Paragraph classNames={['u-space-xl']}>
              With Terminal, users get a personalized web-based dashboard,
              network explorer, and our suite of liquidity tools.
            </Paragraph>
            <Paragraph>
              <Button href="http://terminal.lightning.engineering">
                Lightning Terminal
              </Button>
              <Button
                ghost
                alt
                href="https://docs.lightning.engineering/lightning-network-tools/lightning-terminal/introduction"
              >
                Learn More
              </Button>
            </Paragraph>
          </GridCell>
        </Grid>
      </Container>
    </Section>
    <Section theme="dark-light">
      <Container>
        <Headline heroThin classNames={['u-space-l']}>
          Ready to get started?
        </Headline>
        <Paragraph classNames={['u-space-s']}>
          <Button href="/products">See our products</Button>
        </Paragraph>
        <Paragraph>
          <Button ghost invert href="/join-us">
            Join us
          </Button>
        </Paragraph>
      </Container>
    </Section>
  </Page>
)

export default IndexPage

export const query = graphql`
  query IndexPageQuery {
    markdownRemark(fields: { slug: { eq: "/" } }) {
      frontmatter {
        title
        description
        news {
          title
          url
        }
      }
    }
    screenshot: file(relativePath: { eq: "images/terminal_ss.png" }) {
      id
      relativePath
      childImageSharp {
        gatsbyImageData(
          width: 540
          quality: 90
          transformOptions: {cropFocus: CENTER}
          layout: CONSTRAINED
        )
      }
    }
  }
`
